// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3UbNi","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2pWY7"};